import { render, staticRenderFns } from "./landingPageComponent;.vue?vue&type=template&id=169bc7be"
import script from "./landingPageComponent;.vue?vue&type=script&lang=js"
export * from "./landingPageComponent;.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports